import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDEAT from '@angular/common/locales/de-AT';
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeDEAT, 'de-AT');
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error('[Bootstrap Error]', err);

    // Check if it's the specific "could not find matching config for state" error
    const errorMessage = err?.message || err?.toString() || '';
    if (errorMessage.toLowerCase().includes('could not find matching config for state')) {
      console.error('[Bootstrap] State config matching error detected - cleaning URL and redirecting to home page...');

      // Clean up URL parameters
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);

      // Redirect to home page
      window.location.href = '/';
    }
  });
